module.exports = __webpack_public_path__ + "static/media/index.713deae9.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/sass/index.scss
// module id = 7949
// module chunks = 0